import React, { useContext, useState } from "react";
import { observer } from "mobx-react-lite";

import {
  IonIcon,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
  IonProgressBar,
  IonSearchbar,
  isPlatform,
  useIonModal,
  IonImg,
  IonItem,
  IonLabel,
  IonText,
} from "@ionic/react";

import { add, arrowBack } from "ionicons/icons";

import StandardResponseCategoriesListItem from "./components/StandardResponseCategoriesListItem";
import StandardResponseCategoryDetail from "./components/StandardResponseCategoryDetail";
import { SessionContext } from "../../session";

const StandardResponseCategoriesPage: React.FC = observer(() => {
  const [searchText, setSearchText] = useState("");
  const [selectedItem, setSelectedItem] = useState<string>();

  const session = useContext(SessionContext);
  if (!session) {
    return <></>;
  }

  const handleDismiss = () => {
    dismiss();
  };

  const [present, dismiss] = useIonModal(StandardResponseCategoryDetail, {
    category: selectedItem,
    standardResponseSettings: session.standardResponsesSettings,
    onDismiss: handleDismiss,
  });

  const categories = session.standardResponsesSettings?.categories?.filter(
    (category) =>
      (category ?? "").trim() !== "" &&
      (category ?? "").toUpperCase().includes((searchText ?? "").toUpperCase())
  );

  if (!categories) {
    return <IonProgressBar color="primary" type="indeterminate" />;
  }

  return (
    <IonPage>
      <IonHeader
      //className="ion-no-border"
      >
        <IonToolbar color="primary">
          <IonButtons slot="start">
            {session.windowSize === "small" ? (
              <>
                {/*<IonBackButton defaultHref={`/conversations`}></IonBackButton>*/}
                <IonButton routerLink="/admin">
                  <IonIcon icon={arrowBack} />
                </IonButton>
              </>
            ) : (
              <></>
            )}
          </IonButtons>
          <IonTitle>Standard Response Categories</IonTitle>
          <IonButtons slot="end">
            <IonButton
              shape="round"
              expand="block"
              size="large"
              fill="solid"
              color="light"
              onClick={() => {
                setSelectedItem("");
                present({ cssClass: "modal-create-view" });
              }}
            >
              <IonIcon icon={add} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonProgressBar
          hidden={!session.standardResponsesSettings?.loading}
          type="indeterminate"
        />
        <IonSearchbar
          color="light"
          value={searchText}
          onIonChange={(e) => setSearchText(e.detail.value!)}
        ></IonSearchbar>
        <IonList>
          {categories && categories.length > 0
            ? categories.map((item) => (
                <StandardResponseCategoriesListItem
                  key={item}
                  category={item}
                  onSelectItem={(item) => {
                    setSelectedItem(item);
                    present({ cssClass: "modal-edit-view" });
                  }}
                />
              ))
            : (searchText ?? "") !== "" && (
                <IonItem style={{}} lines="none">
                  <IonLabel className="ion-text-center">
                    <IonImg
                      style={{
                        maxWidth: "250px",
                        margin: "auto",
                        marginTop: "69px",
                      }}
                      src={
                        (searchText ?? "") === ""
                          ? "/assets/images/artboard007.png"
                          : "/assets/images/artboard008.png"
                      }
                    />
                    <p>
                      <strong>
                        <IonText
                          color="dark"
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          {(searchText ?? "") === ""
                            ? ""
                            : " No Search Results"}
                        </IonText>
                      </strong>
                    </p>
                    <p
                      style={{
                        marginTop: "5px",
                      }}
                    >
                      <IonText
                        color="medium"
                        style={{
                          fontSize: "16px",
                        }}
                      ></IonText>
                    </p>
                  </IonLabel>
                </IonItem>
              )}
        </IonList>
      </IonContent>
    </IonPage>
  );
});

export default StandardResponseCategoriesPage;
